import type { Article } from '../model/types'

export const NEWS_CATEGORIES = ['Tất cả', 'Tin sản phẩm', 'Cẩm nang', 'Khuyến mãi', 'Review'] as const

export const ARTICLES: Article[] = [
  { id: 'n1', slug: 'top-5-xe-may-dien-2026',
    title: 'Top 5 xe máy điện bán chạy nhất 2026',
    excerpt: 'Điểm mặt 5 mẫu xe máy điện được khách Việt tin dùng nhất nửa đầu năm 2026 — từ VinFast Klara S tới Yadea G5.',
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=800&q=80',
    date: '02/11/2026', author: 'Xe Điện Việt', category: 'Tin sản phẩm', readTime: 5 },
  { id: 'n2', slug: 'bao-duong-pin-lithium',
    title: 'Hướng dẫn bảo dưỡng pin Lithium đúng cách',
    excerpt: 'Pin là trái tim của xe điện — bảo dưỡng đúng giúp pin bền gấp đôi, đi xa hơn, an toàn hơn.',
    image: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=800&q=80',
    date: '28/10/2026', author: 'KTV Minh', category: 'Cẩm nang', readTime: 7 },
  { id: 'n3', slug: 'so-sanh-xe-dap-xe-may-dien',
    title: 'So sánh xe đạp điện vs xe máy điện cho học sinh',
    excerpt: 'Chọn loại nào phù hợp với con bạn? Phân tích chi tiết về quãng đường, tốc độ, giấy phép và an toàn.',
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80',
    date: '20/10/2026', author: 'Xe Điện Việt', category: 'Cẩm nang', readTime: 6 },
  { id: 'n4', slug: 'khuyen-mai-thang-11',
    title: 'Ưu đãi tháng 11: Giảm đến 2.000.000đ + tặng mũ bảo hiểm',
    excerpt: 'Chương trình khuyến mãi lớn nhất năm cho dòng xe máy điện cao cấp — áp dụng toàn hệ thống.',
    image: 'https://images.unsplash.com/photo-1619771914272-e3c1ba17ba4d?w=800&q=80',
    date: '15/10/2026', author: 'Marketing', category: 'Khuyến mãi', readTime: 3 },
  { id: 'n5', slug: 'review-vinfast-theon-s',
    title: 'Review chi tiết VinFast Theon S sau 6 tháng sử dụng',
    excerpt: 'Trải nghiệm thực tế từ khách hàng — ưu nhược điểm, chi phí vận hành so với xe xăng cùng tầm giá.',
    image: 'https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?w=800&q=80',
    date: '08/10/2026', author: 'Anh Tuấn', category: 'Review', readTime: 10 },
  { id: 'n6', slug: 'xe-dien-an-toan-mua-mua',
    title: 'Xe điện có an toàn khi đi trời mưa không?',
    excerpt: 'Giải đáp thắc mắc muôn thuở — tiêu chuẩn IP chống nước, lưu ý khi đi qua vùng ngập.',
    image: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=800&q=80',
    date: '01/10/2026', author: 'KTV Minh', category: 'Cẩm nang', readTime: 5 },
]
